var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconNounHelp = function SvgIconNounHelp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a1b4b6",
    d: "M8.5 0C3.806 0 0 3.806 0 8.5S3.806 17 8.5 17 17 13.194 17 8.5c0-2.254-.896-4.416-2.49-6.01C12.916.896 10.754 0 8.5 0zm.704 12.04c.003.445-.246.71-.683.71-.437 0-.728-.255-.73-.628 0-.517.232-.774.694-.788.376-.011.767.219.72.706zm1.426-3.883c-.235.197-.48.376-.717.57-.348.247-.548.677-.525 1.128.012.33-.184.625-.476.717-.31.13-.662.015-.855-.278-.062-.112-.095-.24-.098-.37-.024-.823.328-1.605.94-2.09.265-.219.515-.459.748-.717.111-.142.179-.318.194-.503.038-.508-.263-.834-.747-.868-.585-.04-1.077.124-1.419.685-.147.27-.433.414-.718.358-.496-.09-.709-.527-.506-1.03.213-.49.579-.884 1.033-1.111.466-.249.977-.385 1.496-.398.294.033.586.085.874.156.88.27 1.404 1.034 1.47 2.048.065.662-.2 1.31-.696 1.703h.002z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNounHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_noun_help.b3c26360.svg";
export { ForwardRef as ReactComponent };